export default "__VITE_ASSET__fL6rHlc9__"